import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneMasksDirective } from './directives/phone-mask.directive';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { FormatedDatePipe } from './pipes/formated-date.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDateTimePickerComponent } from './components/custom-date-time-picker/custom-date-time-picker.component';
import { DateTimePickerComponent } from './components/date-time-picker/date-time-picker.component';
import { DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { PositiveNumberPipe } from './pipes/positive-number.pipe';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormatedDateTimePipe } from './pipes/formated-datetime.pipe';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { PageSidebarComponent } from './components/page-sidebar/page-sidebar.component';
import { MatSelectModule } from '@angular/material/select';
import { MentionDirective } from './directives/mention.directive';
import { HasModuleDirective } from './directives/has-module.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { InvoiceContactCardComponent } from './components/invoice-contact-card/invoice-contact-card.component';
import { AiAssistantComponent } from './components/ai-assistant/ai-assistant.component';
import { AiRecoCardComponent } from './components/ai-assistant/reco-card/ai-reco-card.component';
import { ChartsModule } from 'ng2-charts';
import {
  MatMomentDateModule,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { MY_DATE_FORMATS } from 'src/app/date-formats';
import { CommonButtonComponent } from './components/common-button/common-button.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    OnlyNumbersDirective,
    PhoneMasksDirective,
    FormatedDatePipe,
    FormatedDateTimePipe,
    PositiveNumberPipe,
    CustomDateTimePickerComponent,
    DateTimePickerComponent,
    PageSidebarComponent,
    MentionDirective,
    HasModuleDirective,
    HasPermissionDirective,
    InvoiceContactCardComponent,
    AiAssistantComponent,
    AiRecoCardComponent,
    CommonButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    DateRangePickerModule,
    MatFormFieldModule,
    MatDatepickerModule,
    NgSelectModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatMomentDateModule,
    ChartsModule,
    MatTooltipModule
  ],
  exports: [
    OnlyNumbersDirective,
    PhoneMasksDirective,
    FormatedDatePipe,
    FormatedDateTimePipe,
    PositiveNumberPipe,
    CustomDateTimePickerComponent,
    DateTimePickerComponent,
    PageSidebarComponent,
    MentionDirective,
    HasModuleDirective,
    HasPermissionDirective,
    InvoiceContactCardComponent,
    AiAssistantComponent,
    AiRecoCardComponent,
    CommonButtonComponent
  ],
  providers: [
    {
      provide: MomentDateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
